import React from 'react';
import { ContentTemplate, Progress, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import RouteKey from '../../../routes/key';
import { useGetNonNationalExamWithdrawalAcknowledgement } from '../../../api-refactored/non-national-exam-registration/useGetNonNationalExamWithdrawalAcknowledgement';
import SubmitApplication from '../../../modules/withdrawal/SubmitApplication';
import { useWOGAA } from '../../../hooks/wogaa';

const { withdrawal } = RouteKey.child;
const { examRegistrations } = RouteKey.exam.child;
const { nonNationalSummary } = RouteKey.withdrawal.child;

const WithdrawalReceipt = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { uuid } = useParams<{ uuid: string }>();

  const {
    data: withdrawalReceiptDetails,
    isLoading: isLoadingWithdrawalReceiptDetails,
  } = useGetNonNationalExamWithdrawalAcknowledgement({
    uuid,
  });
 // Wogaa tracking end for non national withdrawal
  const { transactionEnd } = useWOGAA('myexamsseab-6458');
  transactionEnd(uuid);

  const handleViewFullSummaryClick = () =>
    history.push(`/${withdrawal}/${examRegistrations.route}/${uuid}/${nonNationalSummary.route}`);

  return (
    <>
      <TitleHeader state="success" title={t('withdrawal->>SubmitApplication.ThankYouMessage')} />
      {isLoadingWithdrawalReceiptDetails ? (
        <ContentTemplate>
          <Progress color="secondary" />
        </ContentTemplate>
      ) : (
        <>
          {withdrawalReceiptDetails && (
            <SubmitApplication
              handleViewFullSummaryClick={handleViewFullSummaryClick}
              withdrawalReceiptDetails={withdrawalReceiptDetails}
            />
          )}
        </>
      )}
    </>
  );
};

export default WithdrawalReceipt;
